import styled from '@emotion/styled';
import { Radio } from '@mui/material';

export const Container = styled(Radio)`
  &:hover {
    background: initial;
    opacity: 0.8;
  }
`;
